import { yupResolver } from "@hookform/resolvers/yup";
import { ReceiptTemplateFormValues } from "./types";
import { schema } from "./constants";
import { FormProvider, useForm } from "react-hook-form";
import { defaultFormValues as _defaultFormValues } from "./constants";
export interface ReceiptTemplateFormProps {
  defaultFormValues?: Partial<ReceiptTemplateFormValues>;
  children?: React.ReactNode;
}

export const ReceiptTemplateForm = ({
  defaultFormValues,
  children,
}: ReceiptTemplateFormProps) => {
  const methods = useForm<ReceiptTemplateFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ..._defaultFormValues,
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
